module.exports = __webpack_public_path__ + "img/ammiraglio10.c4714fae.jpeg";